import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/images/shopping-8042865_1280.webp")